import React, { FC } from 'react';

import Fab from '@material-ui/core/Fab';
import UpIcon from '@material-ui/icons/ExpandLessRounded';
import DownIcon from '@material-ui/icons/ExpandMoreRounded';

import Input from '../../../../../../components/Input';
import { NumberPickerStyled } from './NumberPicker.Styles';

interface IProps {
  defaultValue: number;
  value?: number;
  onChange?: (newValue: number) => void;
  disabled: boolean;
}

export const NumberPicker: FC<IProps> = props => {
  const { defaultValue, value, onChange, disabled } = props;

  const currentValue = (isNaN(Number(value)) ? defaultValue : value) as number;

  const add = () => onChange && onChange(currentValue + 1);

  const sub = () => onChange && onChange(currentValue - 1 > 0 ? currentValue - 1 : 0);

  return (
    <NumberPickerStyled>
      <Fab
        color="primary"
        disabled={disabled}
        aria-label="Add"
        className="scorepicker-button"
        onClick={sub}
      >
        <DownIcon />
      </Fab>

      <Input
        outlined={true}
        label=""
        disabled={disabled}
        type="number"
        noIcon={true}
        value={currentValue}
        inputProps={{ min: 0 }}
        onChange={e => onChange && onChange(Number(e.target.value))}
      />

      <Fab
        color="primary"
        disabled={disabled}
        aria-label="Add"
        className="scorepicker-button"
        onClick={add}
      >
        <UpIcon />
      </Fab>
    </NumberPickerStyled>
  );
};
